{
  "use strict";

  document.querySelectorAll("#FacetsWrapperMobile label").forEach(elem => {
    elem.addEventListener("click", e => {
      const input = e.currentTarget.querySelector("input");
      input.click();
    });
  });

    document.querySelectorAll("#FacetsWrapperDesktop label").forEach(elem => {
    elem.addEventListener("click", e => {
      const input = e.currentTarget.querySelector("input");
      input.click();
    });
  });
}